import React from "react";
import { createUseStyles } from "react-jss";
import PageHeader from '../Shared/PageHeader';
import PhotoSection from './Photo';
import { Helmet } from "react-helmet-async";

function GalleryPage() {
    const useStyles = createUseStyles({
        pageContainer: {
            position: "relative",
            height: "100%",
            width: "100%",
            fontFamily: "Open Sans, sans-serif",
            display: "flex",
            flexDirection: " column"
        },
    });
    const styles = useStyles();
    const structuredData = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Gallery | Integrated Holistic Psychotherapy",
  "url": "https://inhop.or.ke/gallery",
  "description": "Browse the gallery of Integrated Holistic Psychotherapy in Ruiru, Nairobi. Explore our spaces, sessions, and activities promoting mental health and wellbeing.",
  "mainEntity": {
    "@type": "ImageGallery",
    "name": "Integrated Holistic Psychotherapy Gallery",
    "url": "https://inhop.or.ke/gallery",
    "image": [
      "https://inhop.or.ke/logo.webp",
      "https://res.cloudinary.com/doosfxptt/image/upload/v1590000302/inhop/IMG_20191217_120506_mqdgyp.jpg",
      "https://res.cloudinary.com/doosfxptt/image/upload/v1589999305/inhop/IMG_20191201_154043_npvrfg.jpg",
      "https://res.cloudinary.com/doosfxptt/image/upload/v1589998885/inhop/IMG_20191201_154015_cjqikh.jpg"
    ]
  }
};

    return (
        <>
            <Helmet>
                <title>Gallery | Integrated Holistic Psychotherapy</title>
                <meta
                    name="description"
                    content="Browse the gallery of Integrated Holistic Psychotherapy in Ruiru, Nairobi. Explore our spaces, sessions, and activities promoting mental health and wellbeing."
                />
                <meta
                    name="keywords"
                    content="psychotherapy gallery Nairobi, counseling photos Ruiru, Integrated Holistic Psychotherapy, therapy center Nairobi, mental health services Kenya"
                />
                <link rel="canonical" href="https://inhop.or.ke/gallery" />

                {/* Open Graph */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://inhop.or.ke/gallery" />
                <meta property="og:title" content="Gallery | Integrated Holistic Psychotherapy" />
                <meta
                    property="og:description"
                    content="View photos of Integrated Holistic Psychotherapy in Ruiru, Nairobi. Our gallery highlights spaces and services that support mental health and wellbeing."
                />
                <meta property="og:image" content="https://inhop.or.ke/logo.webp" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@inhop20" />
                <meta name="twitter:creator" content="@inhop20" />
                <meta name="twitter:url" content="https://inhop.or.ke/gallery" />
                <meta name="twitter:title" content="Gallery | Integrated Holistic Psychotherapy" />
                <meta
                    name="twitter:description"
                    content="Photo gallery of Integrated Holistic Psychotherapy in Ruiru, Nairobi. Explore our environment and services for mental health and wellbeing."
                />
                <meta name="twitter:image" content="https://inhop.or.ke/logo.webp" />

                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>

            <div className={styles.pageContainer}>
                <div className={styles.aboutImageHeader}>
                    <PageHeader pageTitle="Gallery" />
                </div>
                <div>
                    <PhotoSection />
                </div>
            </div>
        </>
    )
}


export default GalleryPage;
